import dayjs from "dayjs";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import ArrayIndex from "../../components/UI/AddingData/ArrayIndex";
import InstanceIndex from "../../components/UI/AddingData/InstanceIndex";
import TextInput from "../../components/UI/AddingData/TextInput";
import { handleLoading } from "../../store/actions/loadingAction";
import { createExpense } from "../../store/actions/expensesAction";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import CommonInputsContainer from "../../components/UI/TableView/CommonInputsContainer";
import useSWR from "swr";
import RequestModal from "../../components/utils/RequestModal";
import ExpensesCalculationPriceModal from "../../components/Expenses/ExpensesCalculationPriceModal";
import PickerInput from "../../components/UI/AddingData/PickerInput";
import { fetcher } from "../../components/UI/TableView/ShowPaginationData";
const smalltalk = require("smalltalk");

const Type = [
  { id: "1", label: "gym" },
  { id: "2", label: "cafeteria" },
];

function AddExpenses() {
  const [currentOrder, setCurrentOrder] = useState(false);

  const _id = useParams().expenseId;
  const currentCenterId = JSON.parse(localStorage.getItem('centerId')).centerId
  const [requestModal, setRequestModal] = useState(false)
  const { data, isLoading, error } = useSWR('/expenses/' + _id, fetcher)

  const history = useHistory();
  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })
  const onChangeValue = (type, value) => {
    let obj = currentOrder;

    if (type === 0) {
      obj.name = value;
    }
    if (type === 1) {
      obj.iqd = Number(value);
    }
    if (type === 2) {
      obj.type = Number(value);
    }

    setCurrentOrder({ ...obj });
  };

  const onSubmit = async (paymentDetails) => {
    try {
      handleLoading();
      await checkValidation();
      const iqd = paymentDetails.payedType === 1 ? paymentDetails.amountByCustomer : paymentDetails.payedType === 0 ? convertCurrency(paymentDetails.amountByCustomer, 'IQD') : paymentDetails.iqdAmount + convertCurrency(paymentDetails.dollarAmount, 'IQD')
      const price = Number(paymentDetails.payedType === 1 ? convertCurrency(paymentDetails.amountByCustomer, 'USD') : paymentDetails.payedType === 0 ? paymentDetails.amountByCustomer : Number(convertCurrency(paymentDetails.iqdAmount, 'USD')) + paymentDetails.dollarAmount)

      let obj = {
        ...currentOrder,
        centerId: currentCenterId,
        price,
        iqd,
        paymentDetails
      };
      await createExpense(obj)
      history.goBack();
      handleLoading();
    } catch (e) {
      handleLoading();
      smalltalk.alert('Error', JSON.stringify(e));
    }
  };

  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  const onSubmitModal = () => {
    const pD = { ...priceModal.paymentDetails, payedType: priceModal.payedType, changeType: priceModal.changeType }
    onSubmit(pD)
    setPriceModal(prev => ({ ...prev, show: false, }))
  }

  const checkValidation = async () => {
    if (!currentOrder.name) {
      throw "Invlaid Name";
    }
    if (!currentOrder.type) {
      throw "Invlaid Type";
    }
  };

  const setUp = () => {
    let objData = {};

    if (data && data.length !== 0 && data[0]) {
      objData = data[0];
    } else
      objData = {
        name: "",
        iqd: null,
        type: null
      };

    setCurrentOrder(objData);
  };
  const onChangeModal = (pck = {}) => {
    if (currentOrder.type === undefined || currentOrder.type === null || !currentOrder.name) {
      alert('please fill all fields')
      return
    }
    setPriceModal(prev => ({ ...prev, show: !prev.show, data: pck.price ? pck : prev.data }))
  }
  useEffect(() => {
    setUp();
  }, [data]);

  const sendRequest = () => {
    setRequestModal(!requestModal)
  }

  return (
    <div className='flex flex-col items-center justify-center flex-1 bg-[#f9f9f9] w-full '>
      {/* {requestModal && <RequestModal data={currentOrder} requestType={4} toggleModal={sendRequest} />} */}
      {requestModal && <RequestModal data={currentOrder} requestType={2} toggleModal={sendRequest} />}
      <ExpensesCalculationPriceModal onSubmit={onSubmitModal} onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />

      <CommonInputsContainer
        onSave={currentOrder?._id ? null : onSubmit}
        title={t('expense')} >
        <InstanceIndex label={t("id")} value={`#${currentOrder && currentOrder._id ? currentOrder._id : ''}`} />
        <InstanceIndex
          label={t("date")}
          value={dayjs(currentOrder.date).format("DD/MM/YYYY")}
        />
        <TextInput
          label={t("name")}
          placeHolder={t("name")}
          value={currentOrder.name}
          onChangeValue={onChangeValue}
          type={0}
        />
        <ArrayIndex
          valType={1}
          value={currentOrder.type}
          data={Type}
          index="id"
          onChangeValue={onChangeValue}
          label={t("type")}
          type={2}
        />
        <PickerInput
          label={t('price')}
          onPress={onChangeModal}
          placeholder={t('selectPrice')}
          value={currentOrder.iqd}
        />
      </CommonInputsContainer>
    </div>
  );
}

const Container = ({ onChangeValue, currentOrder }) => {
  return (
    <div className="w-4/5 mt-10 border">
      <InputContainer
        onChangeValue={onChangeValue}
        currentOrder={currentOrder}
      />
    </div>
  );
};

const InputContainer = ({ onChangeValue, currentOrder }) => {
  const { t } = useTranslation();

  return (
    <div className="items-center justify-center bg-white">
      <TextInput
        label={t("name")}
        placeHolder={t("name")}
        value={currentOrder.name}
        onChangeValue={onChangeValue}
        type={0}
      />
      <TextInput
        label={t("price") + ' (دینار) '}
        placeHolder={t("price")}
        value={currentOrder.iqd}
        onChangeValue={onChangeValue}
        type={1}
        isNumber
      />
      <ArrayIndex
        valType={1}
        value={currentOrder.type}
        data={Type}
        index="id"
        onChangeValue={onChangeValue}
        label={t("type")}
        type={2}
      />
      <InstanceIndex
        label={t("date")}
        value={dayjs(currentOrder.date).format("DD/MM/YYYY")}
      />
      <div className="h-14" />
    </div>
  );
};

export default AddExpenses;
